import { BasePayloadMapper } from '@ps/utils';
import { SurveyEpcEstimateQuery } from '@ps/survey-utils';

import { SurveyEpcEstimateRequestDto } from '../dtos/survey-epc.dto';

export class SurveyEpcEstimatePayloadMapper extends BasePayloadMapper<
  SurveyEpcEstimateQuery,
  SurveyEpcEstimateRequestDto
> {
  public toPayload({
    goal,
    incidence,
    cpi,
    margin,
  }: SurveyEpcEstimateQuery): SurveyEpcEstimateRequestDto {
    return {
      goal: `${goal}`,
      IR: `${incidence}`,
      CPI: `${cpi}`,
      margin,
    };
  }
}
